module.exports = __webpack_public_path__ + "assets/wheel-152958.mp3";